import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function Handelsbetingelser() {
  return (
    <LegalLayout
      title="Handels- og forretningsbetingelser"
      subtitle="Gældende for køb af medlemskaber, Moon Experiences, Moon Gatherings, Moon Treatments, retreats, klippekort, gavekort, produkter og øvrige ydelser hos Moon Yoga."
      path="/handelsbetingelser"
    >
      <div className="text-xs text-brand-muted mb-6 font-medium">
        Senest opdateret: 29.07.2026
      </div>

      {/* 1. Om Moon Yoga */}
      <section className="space-y-3 bg-brand-light-gold/30 border border-brand-primary/10 rounded-2xl p-6 mb-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          1. Om Moon Yoga
        </h2>
        <div className="space-y-1 text-sm font-medium">
          <p className="font-serif font-semibold text-base">Moon Yoga</p>
          <p>Dalegade 61B</p>
          <p>7000 Fredericia</p>
          <p>CVR: 46719395</p>
          <p className="pt-2">
            E-mail: {' '}
            <a href="mailto:yoga@moonyoga-fredericia.dk" className="text-brand-primary hover:underline">
              yoga@moonyoga-fredericia.dk
            </a>
          </p>
          <p>
            Telefon: {' '}
            <a href="tel:+4522393836" className="text-brand-primary hover:underline">
              +45 22 39 38 36
            </a>
          </p>
        </div>
        <p className="pt-3 font-medium text-brand-primary">
          Ved køb hos Moon Yoga accepterer du disse handels- og forretningsbetingelser.
        </p>
      </section>

      {/* 2. Anvendelsesområde */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          2. Anvendelsesområde
        </h2>
        <p>
          Disse handels- og forretningsbetingelser gælder for alle køb foretaget hos Moon Yoga via vores hjemmeside, webshop, bookingsystem (YOGO) eller i studiet.
        </p>
        <p>
          Praktiske regler om booking, ventelister, afmelding, no-show, medlemskaber og deltagelse fremgår af vores Medlems- og tilmeldingsbetingelser, som udgør en del af det samlede aftalegrundlag.
        </p>
      </section>

      {/* 3. Bestilling og betaling */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          3. Bestilling og betaling
        </h2>
        <p>
          Alle priser er angivet i danske kroner (DKK).
        </p>
        <p>
          Betaling sker via de betalingsløsninger, som tilbydes gennem Moon Yoga eller YOGO.
        </p>
        <p>
          Ved køb af medlemskab trækkes første betaling ved oprettelsen. Herefter trækkes betalingen automatisk på den aftalte betalingsdato hver måned, indtil medlemskabet opsiges.
        </p>
        <p>
          Ved køb af øvrige ydelser trækkes betalingen ved gennemført køb, medmindre andet fremgår.
        </p>
        <p>
          Alle betalinger behandles via sikre og krypterede betalingsløsninger.
        </p>
      </section>

      {/* 4. Kvittering */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          4. Kvittering
        </h2>
        <p>
          Når dit køb er gennemført, modtager du en ordrebekræftelse og kvittering pr. e-mail.
        </p>
        <p>
          Kvitteringer for køb foretaget gennem YOGO vil desuden være tilgængelige på din medlemsprofil.
        </p>
      </section>

      {/* 5. Medlemskaber, Moon Experiences og klippekort */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          5. Medlemskaber, Moon Experiences og klippekort
        </h2>
        <p>
          Et medlemskab giver adgang til de ydelser, der fremgår af det valgte medlemskab.
        </p>
        <p>
          En Moon Experience giver adgang til én deltagelse på ét hold pr. købt experience.
        </p>
        <p>
          Medlemskaber, klippekort og Moon Experiences er personlige og kan ikke overdrages til andre.
        </p>
        <p>
          Yderligere vilkår for medlemskaber, booking og opsigelse fremgår af Medlems- og tilmeldingsbetingelserne.
        </p>
      </section>

      {/* 6. Moon Gatherings */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          6. Moon Gatherings
        </h2>
        <p>
          Moon Gatherings omfatter ceremonier, workshops, foredrag og øvrige særlige arrangementer, som annonceres af Moon Yoga.
        </p>
        <p>
          Moon Yoga forbeholder sig retten til at aflyse et Moon Gathering ved færre end fire tilmeldte senest 48 timer før arrangementets start.
        </p>
        <p>
          Ved aflysning tilbydes deltageren enten fuld refundering eller et tilgodebevis.
        </p>
      </section>

      {/* 7. Moon Treatments */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          7. Moon Treatments
        </h2>
        <p>
          Moon Treatments omfatter Roll Shaper, cupping, massage, kropsterapi og øvrige behandlinger, som udbydes af Moon Yoga.
        </p>
        <p>
          Regler om booking, afbestilling og udeblivelse fremgår af Medlems- og tilmeldingsbetingelserne.
        </p>
      </section>

      {/* 8. Retreats */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          8. Retreats
        </h2>
        <p>
          Ved tilmelding til et retreat accepteres de særlige retreatbetingelser, som gælder for det enkelte retreat.
        </p>
        <p>
          Depositum refunderes som udgangspunkt ikke.
        </p>
        <p>
          Øvrige regler om betaling, afbestilling og eventuel tilbagebetaling fremgår af det enkelte retreats betingelser.
        </p>
        <p>
          Hvis Moon Yoga aflyser et retreat, tilbydes deltageren fuld refundering eller et tilgodebevis.
        </p>
      </section>

      {/* 9. Gavekort */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          9. Gavekort
        </h2>
        <p>
          Gavekort er gyldige i 730 dage fra købsdatoen.
        </p>
        <p>
          Gavekort kan ikke ombyttes til kontanter eller udbetales.
        </p>
        <p>
          Gavekort kan anvendes til de ydelser, der udbydes gennem Moon Yogas bookingsystem (YOGO), men kan ikke anvendes til køb af fysiske produkter i studiet.
        </p>
      </section>

      {/* 10. Fysiske produkter */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          10. Fysiske produkter
        </h2>
        <p>
          Ved køb af fysiske produkter via Moon Yogas webshop gælder den lovpligtige 14 dages fortrydelsesret i henhold til forbrugeraftaleloven.
        </p>
        <p>
          For at benytte fortrydelsesretten skal produktet returneres ubrugt, i væsentligt samme stand som ved modtagelsen og – så vidt muligt – i original emballage.
        </p>
        <p>
          Kunden afholder selv de direkte omkostninger ved returnering, medmindre andet følger af gældende lovgivning.
        </p>
        <p>
          Ved køb af fysiske produkter gælder desuden den til enhver tid gældende reklamationsret efter købeloven.
        </p>
        <p>
          Ved køb af produkter direkte i studiet gælder købelovens regler. Der ydes ikke generel bytte- eller returret, medmindre andet er aftalt eller følger af gældende lovgivning.
        </p>
      </section>

      {/* 11. Fortrydelsesret */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          11. Fortrydelsesret
        </h2>
        <p>
          Ved køb af medlemskaber, Moon Experiences, klippekort, Moon Treatments, Moon Gatherings, retreats og øvrige ydelser gælder fortrydelsesretten i overensstemmelse med forbrugeraftaleloven.
        </p>
        <p>
          For ydelser, der leveres på en bestemt dato eller inden for et bestemt tidsrum, herunder blandt andet Moon Gatherings, workshops, ceremonier og retreats, kan fortrydelsesretten være begrænset eller bortfalde i henhold til gældende lovgivning.
        </p>
        <p>
          Hvis en ydelse påbegyndes inden udløbet af fortrydelsesfristen efter kundens udtrykkelige samtykke, kan fortrydelsesretten helt eller delvist bortfalde i overensstemmelse med forbrugeraftaleloven.
        </p>
      </section>

      {/* 12. Ansvar */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          12. Ansvar
        </h2>
        <p>
          Vi gør os umage for at skabe trygge, professionelle og nærværende rammer.
        </p>
        <p>
          Deltagelse i undervisning, behandlinger, Moon Gatherings, retreats og øvrige aktiviteter sker altid på eget ansvar.
        </p>
        <p>
          Det er deltagerens ansvar at informere underviseren eller behandleren om forhold, som kan have betydning for deltagelsen, herunder eksempelvis graviditet, sygdom, skader, operationer, medicin eller andre helbredsmæssige forhold.
        </p>
        <p>
          Moon Yoga kan ikke holdes ansvarlig for personskader eller tab, medmindre dette følger af ufravigelig dansk lovgivning.
        </p>
        <p>
          Moon Yoga kan heller ikke holdes ansvarlig for bortkomne eller beskadigede personlige ejendele.
        </p>
      </section>

      {/* 13. Force majeure */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          13. Force majeure
        </h2>
        <p>
          Moon Yoga kan ikke holdes ansvarlig for manglende opfyldelse af sine forpligtelser, hvis dette skyldes forhold uden for vores rimelige kontrol.
        </p>
        <p>
          Dette omfatter blandt andet naturkatastrofer, brand, oversvømmelse, pandemi, myndighedspåbud, strejke, lockout, længerevarende sygdom, tekniske nedbrud eller andre ekstraordinære hændelser.
        </p>
        <p>
          Hvis Moon Yoga må holde midlertidigt lukket som følge af force majeure, opkræves der ikke betaling i den periode, hvor de aftalte ydelser ikke kan leveres.
        </p>
      </section>

      {/* 14. Persondata */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          14. Persondata
        </h2>
        <p>
          Moon Yoga behandler dine personoplysninger i overensstemmelse med gældende databeskyttelseslovgivning.
        </p>
        <p>
          Du kan læse mere i vores Privatlivspolitik.
        </p>
      </section>

      {/* 15. Ændringer af handels- og forretningsbetingelser */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          15. Ændringer af handels- og forretningsbetingelser
        </h2>
        <p>
          Moon Yoga forbeholder sig retten til at ændre disse handels- og forretningsbetingelser, når det er nødvendigt.
        </p>
        <p>
          Væsentlige ændringer varsles på hjemmesiden eller pr. e-mail med rimeligt varsel.
        </p>
        <p>
          Den til enhver tid gældende version er altid tilgængelig på vores hjemmeside.
        </p>
      </section>

      {/* 16. Lovvalg og værneting */}
      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          16. Lovvalg og værneting
        </h2>
        <p>
          Disse handels- og forretningsbetingelser er underlagt dansk ret.
        </p>
        <p>
          Eventuelle tvister afgøres efter dansk lovgivning ved de danske domstole.
        </p>
      </section>

      {/* 17. Kontakt */}
      <section className="space-y-3 bg-brand-light-gold/30 border border-brand-primary/10 rounded-2xl p-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          17. Kontakt
        </h2>
        <p>
          Har du spørgsmål til disse handels- og forretningsbetingelser, er du altid velkommen til at kontakte os.
        </p>
        <div className="space-y-1 text-sm font-medium pt-2">
          <p className="font-serif font-semibold text-base">Moon Yoga</p>
          <p>Dalegade 61B</p>
          <p>7000 Fredericia</p>
          <p className="pt-2">
            📧 {' '}
            <a href="mailto:yoga@moonyoga-fredericia.dk" className="text-brand-primary hover:underline">
              yoga@moonyoga-fredericia.dk
            </a>
          </p>
          <p>
            📞 {' '}
            <a href="tel:+4522393836" className="text-brand-primary hover:underline">
              +45 22 39 38 36
            </a>
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
